import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { Table } from '../../../../common/Table';
import DateCell from '../../../../common/cells/DateCell';
import Loader from '../../../../common/Loader';
import { DATE_TIME_FORMAT } from '../../../../../config/locale';
import { DEPOSIT_EDIT_HISTORY_FIELD_LABEL } from '../../../../../config/constants';

const ADDED_BANK_ACCOUNT_LABEL = 'Se agregó una cuenta';
const REMOVED_BANK_ACCOUNT_LABEL = 'Se quitó una cuenta';

const fieldLabel = ({ fieldName, oldValue, newValue }) => {
  if (fieldName === 'depositBankAccount') {
    if (oldValue === null) return ADDED_BANK_ACCOUNT_LABEL;
    if (newValue === null) return REMOVED_BANK_ACCOUNT_LABEL;
  }

  return DEPOSIT_EDIT_HISTORY_FIELD_LABEL[fieldName] || fieldName;
};

const valueCell = ({ value }) =>
  value === null || value === undefined || value === '' ? '-' : value;

const EDIT_HISTORY_COLUMNS = [
  {
    Header: 'Fecha',
    accessor: 'createDate',
    className: 'text-center',
    Cell: (row) => <DateCell format={DATE_TIME_FORMAT} value={row.value} />,
  },
  {
    Header: 'Campo',
    accessor: 'fieldName',
    className: 'text-center',
    Cell: (row) => fieldLabel(row.original),
  },
  {
    Header: 'Valor Anterior',
    accessor: 'oldValue',
    className: 'text-center',
    Cell: valueCell,
  },
  {
    Header: 'Valor Nuevo',
    accessor: 'newValue',
    className: 'text-center',
    Cell: valueCell,
  },
  {
    Header: 'Operador',
    accessor: 'operatorUserName',
    className: 'text-center',
    Cell: (row) => row.value || row.original.operatorUserId || '-',
  },
];

const DepositEditHistoryResource = ({ editHistory, loading }) => {
  let content = null;

  if (loading) {
    content = <Loader />;
  } else if (editHistory.isEmpty()) {
    content = <p className="text-muted">Este depósito no ha sido editado.</p>;
  } else {
    const editHistoryList = editHistory.toJS();

    content = (
      <Table
        columns={EDIT_HISTORY_COLUMNS}
        data={editHistoryList}
        defaultPageSize={editHistoryList.length}
        showPagination={false}
      />
    );
  }

  return (
    <>
      <h3>Historial de Ediciones</h3>
      {content}
      <br />
    </>
  );
};

DepositEditHistoryResource.propTypes = {
  editHistory: PropTypes.instanceOf(Immutable.List).isRequired,
  loading: PropTypes.bool,
};

DepositEditHistoryResource.defaultProps = {
  loading: false,
};

export default DepositEditHistoryResource;
